import { V4_VARIANT } from './v4/theme';
import { V5_VARIANT } from './v5/theme';
import { V6_VARIANT } from './v6/theme';
import { V7_VARIANT } from './v7/theme';

/* v3 has a single fixed dark palette; same token slots so swatches render uniformly. */
const V3_TOKENS = { bg: '#060d07', cyan: '#76c442', text: '#e6f2e0' };

/**
 * All selectable UIs, in menu order. `base` is the route prefix of the
 * variant's pages, `signIn` its login route. `tokens` (per mode) feed the
 * color swatches in the theme pickers.
 */
export const UI_VARIANTS = [
  { id: 'v4', label: 'Standard',    base: '',    signIn: '/',          tokens: V4_VARIANT.tokens },
  { id: 'v5', label: 'Gewächshaus', base: '/v5', signIn: '/v5/signin', tokens: V5_VARIANT.tokens },
  { id: 'v6', label: 'Raster',      base: '/v6', signIn: '/v6/signin', tokens: V6_VARIANT.tokens },
  { id: 'v7', label: 'Terminal',    base: '/v7', signIn: '/v7/signin', tokens: V7_VARIANT.tokens },
  { id: 'v3', label: 'Classic',     base: '/v3', signIn: '/v3/signin', tokens: { dark: V3_TOKENS, light: V3_TOKENS } },
];

const BASE_RE = /^\/v[3-7](?=\/|$)/;

/** Same page in another variant: /v5/analytics → /v6/analytics, sign-in → sign-in. */
export function variantPath(target, pathname) {
  const rest = pathname.replace(BASE_RE, '');
  const onSignIn = rest === '' || rest === '/' || rest === '/signin';
  return onSignIn ? target.signIn : target.base + rest;
}
